import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router-dom';
import LanguageSwitcher from './LanguageSwitcher';

const Header = () => {
  const { t } = useTranslation();
  const location = useLocation();
  
  const scrollToFeatures = () => {
    const featuresElement = document.querySelector('.features-section');
    if (featuresElement) {
      featuresElement.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <header className="header">
      <h1 className="main-title">
        <Link to="/" className="title-link">
          <img src="/apple-touch-icon.png" alt="Logo" className="logo-icon" style={{width: '40px', height: '40px', marginRight: '10px'}} />
          {t('app.title')}
        </Link>
      </h1>
      <div className="header-right">
        <Link to="/blog" className={`nav-button ${location.pathname === '/blog' ? 'active' : ''}`}>
          {t('header.blog')}
        </Link>
        {location.pathname === '/' && (
          <button className="nav-button" onClick={scrollToFeatures}>
            {t('header.features')}
          </button>
        )}
        <LanguageSwitcher />
      </div>
    </header>
  );
};

export default Header; 